import { render, staticRenderFns } from "./PragmaticIframe.vue?vue&type=template&id=ba70f6e2"
import script from "./PragmaticIframe.vue?vue&type=script&lang=js"
export * from "./PragmaticIframe.vue?vue&type=script&lang=js"
import style0 from "./PragmaticIframe.vue?vue&type=style&index=0&id=ba70f6e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.8.1_webpack@5.88.2__lodash@4.17.21_vu_1c5e544e9f835cad48bdf98c6a8f8d59/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports